import { Tag } from 'lucide-react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '../../../components/ui/dialog';
import { AccountTagsInput } from '../../../features/account-tags';
import { useAccountStore } from '../../../entities/account';
import { accountsApi } from '../../../shared/api/accounts.api';
import { toast } from 'sonner';
import type { Account } from '../../../entities/account';

interface AccountTagsDialogProps {
  account: Account;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

/**
 * Widget: Диалог управления тэгами аккаунта
 * Композирует AccountTagsInput (feature) + логику сохранения
 */
export function AccountTagsDialog({ account, open, onOpenChange }: AccountTagsDialogProps) {
  const updateAccount = useAccountStore((state) => state.updateAccount);
  const tags = account.tags || [];

  const handleTagsChange = async (newTags: string[]) => {
    // Оптимистичное обновление UI
    updateAccount(account.id, { tags: newTags });

    try {
      // Синхронизация с бэкендом
      await accountsApi.update(account.id, { tags: newTags });
    } catch (error) {
      // Откатываем изменения при ошибке
      updateAccount(account.id, { tags });
      toast.error('Не удалось сохранить тэги');
      console.error('Error updating tags:', error);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Tag className="h-5 w-5" />
            Тэги аккаунта
          </DialogTitle>
          <DialogDescription>
            Добавьте тэги для организации и фильтрации аккаунтов
          </DialogDescription>
        </DialogHeader>
        <div className="py-4">
          <AccountTagsInput
            tags={tags}
            onChange={handleTagsChange}
            placeholder="Введите тэг и нажмите Enter..."
          />
        </div>
      </DialogContent>
    </Dialog>
  );
}
